var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconChevronDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_chevron-down",
    "data-name": "Icon / chevron-down",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 8.688,
    viewBox: "0 0 16 8.688",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevron-down",
    d: "M15.874.381,15.619.126a.431.431,0,0,0-.61,0L8,7.138.991.126a.431.431,0,0,0-.61,0L.126.381a.431.431,0,0,0,0,.61L7.694,8.561a.431.431,0,0,0,.61,0L15.87.991A.428.428,0,0,0,15.874.381Z",
    transform: "translate(16 8.688) rotate(180)",
    fill: "#1a1a1a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconChevronDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon - chevron-down.64e78a4307a3d1bd8be9ec2b1df46e94.svg";